import { AnchorHTMLAttributes, DetailedHTMLProps } from 'react';
import { LinkProps } from 'react-router-dom';

export type BasicLinkProps = DetailedHTMLProps<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
> & {
  to?: never;
};

export type RouterLinkProps = LinkProps & {
  href?: never;
};

export const isRouterLink = (
  linkProps: BasicLinkProps | RouterLinkProps,
): linkProps is RouterLinkProps => {
  return typeof linkProps.to !== 'undefined';
};
